<template>

<component :is="component" :to="to" class="item" v-on:click="onClick">

	<app-icon :icon="icon" class="item-icon" />

	<div class="item-text">{{ text }}</div>

</component>

</template>

<script>

export default {

	props: ['route', 'icon', 'text'],

	computed: {

		component: function() {

			return (this.route) ? 'router-link' : 'div'

		},

		to: function() {

			return (this.route) ? { name: this.route } : false

		}

	},

	methods: {

		onClick: function() {

			if (this.route) return false

			this.$emit('click')

		}

	}

}

</script>

<style scoped>

.item {
	cursor: pointer;
	padding: 12px 0px;
	flex-shrink: 0;
	transition: all 100ms linear;
	display: grid;
	grid-template-columns: 64px 1fr;
	align-items: center;
	grid-gap: 5px;
}

.item.router-link-active {
	background-color: #4082d3;
}

.item:not(.router-link-active):hover {
	background-color: #11316e;
}

.item-icon {
	color: #fff;
	font-size: 24px;
	line-height: 24px;
	text-align: center;
}

.item-text {
	font-size: 16px;
	color: #fff;
	font-weight: 500;
}

.item.router-link-active .item-icon,
.item.router-link-active .item-text {
	color: #fff;
}

</style>
